var map = {
	"./en/index.ts": 682,
	"./it/index.ts": 686,
	"./ua/index.ts": 689
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 681;



//////////////////
// WEBPACK FOOTER
// ./src/common/translate/translations ^\.\/.*\/index\.ts$
// module id = 681
// module chunks = 0